export default __webpack_public_path__ + "static/media/people-outline.ded0d70f.svg";